import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

interface Props {
  offerPrice?: number;
  contract: Contract;
}

const PurchasePrice = ({ offerPrice, contract }: Props) => {
  const formatCurrency = (amount?: number) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <View style={styles.section}>
      <Text style={styles.title}>PURCHASE PRICE</Text>
      <View style={styles.list}>
        <Text>
          The Purchase Price for the Property is{' '}
          <Text style={styles.InfoText}>
            {formatCurrency(contract?.agentOfferInfo.offerPrice)}
          </Text>{' '}
          (hereinafter referred to as the "Purchase Price").
        </Text>
      </View>
    </View>
  );
};

export default PurchasePrice;
